import type { QuoteAsset } from '../../api/tradingTypes'

/**
 * Equivalent of legacy `V3QuoteAssetSelectorComponent`: the "Coin pair quote
 * asset:" dropdown. Shows "any coin pair" (`-`) when `anyValueEnabled`, then
 * every quote asset the user actually uses (`used == 1`, or all with
 * `showAll`). The caller owns the value and its persistence
 * (`quoteAssetStorage.ts`).
 */
export function QuoteAssetSelector({
  value,
  quoteAssets,
  onChange,
  anyValueEnabled = true,
  showAll = false,
}: {
  value: string
  quoteAssets: QuoteAsset[]
  onChange: (coin2: string) => void
  anyValueEnabled?: boolean
  showAll?: boolean
}) {
  const options = quoteAssets.filter((q) => showAll || Number(q.used) === 1).map((q) => q.coin2)
  return (
    <label className="portal-inline-actions">
      Coin pair quote asset:
      <select aria-label="Coin pair quote asset" value={value} onChange={(e) => onChange(e.target.value)}>
        {anyValueEnabled && <option value="-">any coin pair</option>}
        {!options.includes(value) && value !== '-' && <option value={value}>{value}</option>}
        {options.map((coin2) => (
          <option key={coin2} value={coin2}>
            {coin2}
          </option>
        ))}
      </select>
    </label>
  )
}
